<script setup lang="ts">
import { ref } from 'vue'

withDefaults(
  defineProps<{
    noPadding?: boolean
  }>(),
  {
    noPadding: false,
  }
)
const emit = defineEmits<{ (emit: 'hide'): void }>()

const isShown = ref(false)

const show = () => {
  document.body.classList.add('_locked')
  isShown.value = true
}

const hide = () => {
  emit('hide')
  document.body.classList.remove('_locked')
  isShown.value = false
}

defineExpose({
  show,
  hide,
  isShown,
})
</script>

<template>
  <transition>
    <div v-if="isShown" class="modal">
      <div class="modal__body" :class="{ 'modal__body_no-paddding': noPadding }">
        <slot />
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 40000;
  background-color: rgba($color: #0d0802, $alpha: 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  &__body {
    position: relative;
    padding: 32px;
    background-color: $white;
    border-radius: 20px;
    &_no-paddding {
      padding: 0;
    }
  }

  &__button {
    top: -22px;
    right: -22px;
    position: absolute;
    z-index: 1000;
    width: 49px;
    height: 49px;

    * {
      width: 100%;
      height: 100%;
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
